import { TranslateFnType } from 'store'

export type SizeRunFilterType =
  | 'defFemaleInch'
  | 'defFemaleInt'
  | 'defFemaleKonf'
  | 'defFemaleCups'
  | 'defFemaleEur'
  | 'defFemaleRings'
  | 'defFemaleCm'
  | 'defMaleInch'
  | 'defMaleKonf'
  | 'defMaleInt'
  | 'defMaleEur'
  | 'defMaleRings'
  | 'defMaleCm'
  | 'defMaleCollar'
  | 'defKidsEur'
  | 'defKidsInt'
  | 'defKidsCm'
  | 'defFemaleHead'
  | 'defMaleHead'
  | 'defKidsHead'
  | 'fallback_generic_size'

export const getSizeRunFilterTranslations = ({
  sizeRunType,
  t,
}: {
  sizeRunType: SizeRunFilterType
  t: TranslateFnType
}) => {
  const translations = {
    defFemaleInch: t('defFemaleInch'),
    defFemaleInt: t('defFemaleInt'),
    defFemaleKonf: t('defFemaleKonf'),
    defFemaleCups: t('defFemaleCups'),
    defFemaleEur: t('defFemaleEur'),
    defFemaleRings: t('defFemaleRings'),
    defFemaleCm: t('defFemaleCm'),
    defMaleInch: t('defMaleInch'),
    defMaleKonf: t('defMaleKonf'),
    defMaleInt: t('defMaleInt'),
    defMaleEur: t('defMaleEur'),
    defMaleRings: t('defMaleRings'),
    defMaleCm: t('defMaleCm'),
    defMaleCollar: t('defMaleCollar'),
    defKidsEur: t('defKidsEur'),
    defKidsInt: t('defKidsInt'),
    defKidsCm: t('defKidsCm'),
    defFemaleHead: t('defFemaleHead'),
    defMaleHead: t('defMaleHead'),
    defKidsHead: t('defKidsHead'),
    fallback_generic_size: t('Größe'),
  }

  return translations[sizeRunType]
}
